import PropTypes from 'prop-types'
import classNames from 'classnames'

import SearchInput from '../../common/SearchInput'

import classes from './MembersSearchInput.module.scss'

const MembersSearchInput = (props) => (
  <SearchInput {...props} className={classNames(classes.searchInput, { [props.className]: !!props.className })} />
)

MembersSearchInput.propTypes = {
  className: PropTypes.string,
}

export default MembersSearchInput
